import { Injectable } from '@angular/core';
import { MwHttpService } from '@core/http';
import { Observable } from 'rxjs';
import { CountryApiModel } from '../models/country-api.model';

@Injectable()
export class MwCountriesApiService {
  constructor(private http: MwHttpService) {}

  getCountries(): Observable<CountryApiModel[]> {
    return this.http.authGet<CountryApiModel[]>(`/integration/v1/Countries`);
  }
}
